import { customGoal, goalWithValue, stage, trackWithDefaultStage } from "@flights/et-universal";
import etMicroConversion from "../../utils/et-microconversion.js";
import { isOfMetaOrigin } from "../marketing-url-params.js";
import { debugTrackingNames } from "@flights/et-universal";
import { trackMetaCustomGoal, trackMetaExperimentStage } from "../meta-et-tracking.js";
export function createTrackingUtils(config) {
    debugTrackingNames.set(config);
    return {
        name: () => config.name,
        trackWithDefaultStage: () => trackWithDefaultStage(config.name, config.defaultStage),
        stages: createNumericTrackingUtils(stage, config.name, config.stages),
        goals: createNumericTrackingUtils(customGoal, config.name, config.goals),
        goalsWithValue: createCustomGoalWithValueTrackingUtilsV2(config.goalsWithValue)
    };
}
function createCustomGoalWithValueTrackingUtilsV2(goals = []) {
    const utilMap = {};
    goals.forEach((goal) => {
        utilMap[goal] = (value) => goalWithValue(goal, value);
    });
    return utilMap;
}
function createMetaCustomGoalWithValueTrackingUtils(goals = []) {
    const utilMap = {};
    goals.forEach((goal) => {
        utilMap[goal] = (value) => isOfMetaOrigin() && goalWithValue(goal, value);
    });
    return utilMap;
}
function createNumericTrackingUtils(trackingFn, expName, indexMap) {
    const utilMap = {};
    for (const [name, index] of Object.entries(indexMap)) {
        utilMap[name] = () => trackingFn(expName, index);
    }
    return utilMap;
}
export function createMetaTrackingUtils(config) {
    debugTrackingNames.set(config);
    return {
        name: () => config.name,
        trackWithDefaultStage: () => (isOfMetaOrigin() ? trackWithDefaultStage(config.name, config.defaultStage) : 0),
        stages: createNumericTrackingUtils(trackMetaExperimentStage, config.name, config.stages),
        goals: createNumericTrackingUtils(trackMetaCustomGoal, config.name, config.goals),
        goalsWithValue: createMetaCustomGoalWithValueTrackingUtils(config.goalsWithValue)
    };
}
export function createMicroConversionTrackingUtils(config) {
    debugTrackingNames.set(config);
    return {
        name: () => config.name,
        trackWithDefaultStage: () => etMicroConversion.trackWithDefaultStage(config.name, config.defaultStage),
        stages: createNumericTrackingUtils((hashedTagname, id) => {
            etMicroConversion.stage(hashedTagname, id, id === config.mainStage);
        }, config.name, config.stages),
        goals: createNumericTrackingUtils(etMicroConversion.customGoal, config.name, config.goals),
        goalsWithValue: createCustomGoalWithValueTrackingUtilsV2(config.goalsWithValue)
    };
}
